<template>
  <div class="sc__systems-issues__results">
    <div
      v-if="!hasNoContentResults"
      class="sc__systems-issues__results-content"
    >
      <div v-if="hasResults(contentVideoResults)">
        <ScContentVideoResults
          class="sc__systems-issues__results-content--video-results"
          :videos="contentVideoResults.contentDetails"
        >
          <template #pagination>
            <ScPagination
              :ga-event-string="`${systemConfig.mode} - Search,Back Link,Back to Previous`"
              :back-link-text="translations.commonSettings.navigation.back"
              :show-more-link-text="translations.commonSettings.navigation.showMore"
              :showing-text="translations.commonSettings.navigation.showing"
              :of-text="translations.commonSettings.navigation.of"
              show-back-link
              :total-count="contentVideoResults.contentCount"
              :current-count="contentVideoResults.contentDetails.length"
              @show-more="onVideosShowMore"
              @pag-back="$router.push({ name: 'landing' })"
            />
          </template>
        </ScContentVideoResults>
      </div>
      <div v-if="hasResults(contentResults)">
        <ScContentTextResults
          class="sc__systems-issues__results-content--text-results"
          :results="contentResults.contentDetails"
          @on-result-selected="onResultSelected"
        >
          <template #pagination>
            <ScPagination
              :ga-event-string="`${systemConfig.mode} - Search,Back Link,Back to Previous`"
              :back-link-text="translations.commonSettings.navigation.back"
              :show-more-link-text="translations.commonSettings.navigation.showMore"
              :showing-text="translations.commonSettings.navigation.showing"
              :of-text="translations.commonSettings.navigation.of"
              show-back-link
              :total-count="contentResults.contentCount"
              :current-count="contentResults.contentDetails.length"
              @show-more="onContentShowMore"
              @pag-back="$router.push({ name: 'landing' })"
            />
          </template>
        </ScContentTextResults>
      </div>
    </div>
    <div v-else>
      <!-- eslint-disable max-len -->
      <ScContentNoResultsFound
        back-nav-enabled
        :search-in-alt-locale-text="translations.results.alternateLocaleSearch.alternateSearchPrompt"
        :search-in-original-locale-text="translations.results.alternateLocaleSearch.alternateLocaleExit"
        :alternate-locale-enabled="translations.results.alternateLocaleSearch.alternateSearchLocaleActiveFlag"
        :error-message-text="translations.results.keywordSearchNoResultsHeading"
        :suggestions="translations.results.suggestions"
        :try-text="translations.results.keywordSearchSuggestionsHeading"
        :back-text="translations.commonSettings.navigation.clearSearchCritieraLabel"
        :searched-item="getNoResultsSearchedText"
        @on-back-link-click="$router.push({ name: 'landing' })"
      />
    <!-- eslint-enable max-len -->
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss" src="./style.scss"></style>
